import { Component, OnInit } from '@angular/core';
import { PoliticaDePrivacidade } from '../model/politica-de-privacidade.model';
import { PoliticaDePrivacidadeService } from '../politica-de-privacidade.service';

@Component({
  selector: 'app-politica-de-privacidade-modal',
  templateUrl: './politica-de-privacidade-modal.component.html',
  styleUrls: ['./politica-de-privacidade-modal.component.css']
})
export class PoliticaDePrivacidadeModalComponent implements OnInit {

  politica: PoliticaDePrivacidade = null;
  _exibir = false;

  constructor(
    private politicaDePrivacidadeService: PoliticaDePrivacidadeService
  ) { }

  ngOnInit(): void {
  }
  
  buscarPoliticaAtiva(): void {
    this.politicaDePrivacidadeService
        .buscarPoliticaAtiva()
        .subscribe((politica: PoliticaDePrivacidade) => {
          this.politica = politica
        });
  }

  exibir(): void {
    this._exibir = true;
    this.buscarPoliticaAtiva();
  }

  esconder(): void {
    this._exibir = false;
  }

}
